if (typeof allFormSettings !== 'undefined')
{
	// Only log stuff to the console if the env is not 'production'
	// const showDebug = true;
	//const showDebug = allFormSettings.site_env != 'production';
	const showDebug = false;

	// Main Donation Captcha Callback
	window.onMainDonationSubmit = function(token)
	{

		// Processing Step 2
		if(showDebug) console.log('onMainDonationSubmit');
		if(showDebug) console.log(token);

		if(showDebug) console.log("CAPTCHA verified...");
		document.querySelector(".main-donation-form .jsOverlayProgressBar").value = 2;

		// Add token to input on the form
		document.getElementById('main-donation-captcha-response').value = token;
		// Trigger submit
		document.getElementById("main-donation-form-1").dispatchEvent(new Event("submit", { cancelable: true }));
		// document.getElementById('main-donation-form').-();
	}

	// Sidebar Donation Captcha Callback
	window.onSidebarDonationSubmit = function(token)
	{
		if(showDebug) console.log('onSidebarDonationSubmit');
		if(showDebug) console.log(token);

		if(showDebug) console.log("CAPTCHA verified...");
		document.querySelector(".sidebar-donation-form .jsOverlayProgressBar").value = 2;

		// Add token to input on the form
		document.getElementById('sidebar-donation-captcha-response').value = token;
		// Trigger submit
		document.getElementById("sidebar-donation-form-1").dispatchEvent(new Event("submit", { cancelable: true }));
		// document.getElementById('sidebar-donation-form').submit();
	}

	// Donation Captcha OnLoad Callback
	// var mainDonationCaptcha;
	// var sidebarDonationCaptcha;:43
	onloadDonationCaptchaCallback = function()
	{
		if(showDebug) console.group('onloadDonationCaptchaCallback()');
		let	grecaptchaOptions = {
			'sitekey': '6LfymKYUAAAAABK35ZzfOkJqk6mMQ3b778prHTNd',
			'size': 'invisible',
			'badge': 'inline',
		}
		// Main Donation Captcha
		if ( document.getElementById('main-donation-form-1') )
		{
			if(showDebug) console.log('#main-donation-form-1 exists');
			grecaptchaOptions['callback'] = window.onMainDonationSubmit;
			window.mainDonationCaptcha = grecaptcha.render('main-donation-captcha', grecaptchaOptions);
		}
		// Sidebar Donation Captcha
		if ( document.getElementById('sidebar-donation-form-1') )
		{
			if(showDebug) console.log('#sidebar-donation-form-1 exists');
			grecaptchaOptions['callback'] = window.onSidebarDonationSubmit;
			window.sidebarDonationCaptcha = grecaptcha.render('sidebar-donation-captcha', grecaptchaOptions);
		}
		if(showDebug) console.groupEnd();
	}

	// Require libs:69
	const { text } = require('d3');

	// Server endpoint to generate the Link Token
    const linkTokenEndpoint = '/make-gift/fetchLinkToken.php';

	// Global vars
	var stripe = null;
	var clientSecret = null;
	var default_err_msg = "Oh no! The donation failed to process. Please refresh your browser and try again.";

	// Utility for including js file
	function include(url, callback)
	{
		var script = document.createElement('script');
		// script.onload = fn;
		script.src = url;
		script.async = false;
		script.addEventListener('load', callback);
		document.getElementsByTagName("head")[0].appendChild(script);
	}

	// Utility for checking for valid JSON
	function isValidJSON(text) {
		try
		{
			JSON.parse(text);
			return true;
		}
		catch
		{
			return false;
		}
	}

	// Utility for generating error json
	function setError(err_msg)
	{
		/*
	Example:
	{
		"status":"error",
		"code":"400",
		"message":"No such customer: 'cus_FkqinVnSVN3u83'; a similar object exists in live mode, but a test mode key was used to make this request."
	}
		*/
		error = true;
		let errorJSON = {
			"status": "error",
			"code": "400",
			"message": err_msg
		};
		return errorJSON;
	}

	// Create the class for the Custom Element
	// class DonationForm extends HTMLElement
	class DonationForm
	{
		constructor(form, allFormSettings)
		{
			// dfc = Donation Form Container
			this.dfc = form;
			this.allFormSettings = allFormSettings;
			if (this.dfc) this.init();
		}

		// Runs when component is created
		init()
		{
			// Get namespace var
			this.ns = this.dfc.dataset.ns;

			// Assign the settings for the specific block
			this._settings = allFormSettings[this.ns + 'settings'];

			// Required libs
			this.mailcheck = require('mailcheck');
	/*
		----------------------------------------------------------------------
			Properties
		----------------------------------------------------------------------
	*/
			this.form = this.dfc.querySelector('.jsDonationForm');
			// this.paginationControls = this.dfc.querySelectorAll('.jsPaginateTo');
			this.paymentMethod = 'card';
			this.navButtonPrev = this.dfc.querySelectorAll('.jsPrevPage');
			this.navButtonNext = this.dfc.querySelectorAll('.jsNextPage');
			this.hiddenFields = this.dfc.querySelector('.jsHiddenFields');
			this.formPages = this.dfc.querySelectorAll('.jsFormPage');
			// Which type of recurrences should we show [true/false]
			this.recurrenceTypes =
			{
				single: (this.form.dataset.showSingle.toLowerCase() === 'true'),
				monthly: (this.form.dataset.showMonthly.toLowerCase() === 'true'),
				annual: (this.form.dataset.showAnnual.toLowerCase() === 'true'),
			};
			this.defaultRecurrence = this.form.dataset.defaultRecurrence;
			this.form.dataset.recurrence = this.defaultRecurrence;
			this.hasSuggestedAmountsText = this.dfc.querySelector('.jsHasSuggestedAmountsText');
			this.donationRecurrenceText = this.dfc.querySelector('.jsDonationRecurrenceText');
			this.donationNoteRecurrenceText = this.dfc.querySelector('.jsDonationNoteRecurrenceText');
			this.giveButtonText = this.dfc.querySelector('.jsGiveButtonText');

			// this.suggestedAmountsWrapper = this.dfc.querySelector('.suggestedAmounts');
			this.amountWrapper = this.dfc.querySelector('.amountWrapper');

			// Minimum Donations
			this.min =
			{
				single: this.form.dataset.minSingle,
				monthly: this.form.dataset.minMonthly,
				annual: this.form.dataset.minAnnual
			}

			// Define error messages
			this.errorMessages = {}
			this.errorMessages[this.ns + 'targetAmount'] =
			{
				generic: "Please specify an amount to donate.",
				rangeUnderflow:
				{
					// Pre and post the minimum amount, fetched dynamically
					pre: "There is a $",
					post: " minimum on donations of this type.",
				}
			};
			this.errorMessages[this.ns + 'first_name'] =  "Please enter your first name.";
			this.errorMessages[this.ns + 'last_name'] =  "Please enter your last name.";
			this.errorMessages[this.ns + 'email'] =  "Please enter your email.";
			this.errorMessages[this.ns + 'phone'] =  "Please enter your phone number.";
			this.errorMessages[this.ns + 'country'] =  "Please select your country of residence.";
			this.errorMessages[this.ns + 'state'] =  "Please select a state from the list.";
			this.errorMessages[this.ns + 'zip'] =  "Please enter your zip/postal code.";
			this.errorMessages[this.ns + 'city'] =  "Please enter your city.";
			this.errorMessages[this.ns + 'address'] =  "Please provide your street address.";

			// Amount fields
			this.visibleAmountField = this.dfc.querySelector('.jsVisibleAmount');
			this.totalAmountField = this.dfc.querySelector('.jsTotalAmount');
			this.targetAmount = null;
			this.amountIsDirty = false; // The amount field is considered "dirty" if the user has changed the value therein

			// Transaction fees
			this.transactionFeesCheckbox = this.dfc.querySelector('.jsCoverFees');
			this.feesLabel = this.dfc.querySelector('.jsTransactionFeesLabel');
			this.feesAmounts = this.dfc.querySelectorAll('.jsFeesAmount');
			this.feesCheckedText = this.feesLabel.querySelector('.is-checked');
			this.feesUncheckedText = this.feesLabel.querySelector('.not-checked');

			// Summary
			this.summaryAmounts = this.dfc.querySelectorAll('.jsSummaryAmount');
			this.summaryCoverFees = this.dfc.querySelectorAll('.jsSummaryCoverFees');
			this.summaryRecurrences = this.dfc.querySelectorAll('.jsSummaryRecurrence');
			// this.summaryFees = this.dfc.querySelectorAll('.jsSummaryFees');

			this.customerId = this.dfc.querySelector('[name="customer_id"]');

			this.inHonorOfWrapper = this.dfc.querySelector('.inHonorOfWrapper');

			// Credit Card
			this.card = null;
			this.cardElement = document.getElementById(`${this.ns}card-element`);
			this.cardErrors = document.getElementById(`${this.ns}card-errors`);

			// Loading Screen (on /give/ pages or whatever uses the minimal.twig template)
			this.loadingScreens = document.querySelectorAll(`.jsGivePageLoadingScreen`);
			this.loadingScreens.forEach(loadingScreen => {
				loadingScreen.classList.add('-loaded');
			});

			// Captcha
			if ( this.form.dataset.formLocation == 'sidebar' )
			{
				this.donationCaptchaResponse = document.getElementById('sidebar-donation-captcha-response');
			}
			else
			{
				this.donationCaptchaResponse = document.getElementById('main-donation-captcha-response');
			}

			// Overlay
			this.overlay = this.dfc.querySelector('.jsOverlay');
			this.overlayHeading = this.dfc.querySelector('.jsOverlayHeading');
			this.overlayText = this.dfc.querySelector('.jsOverlayText');
			this.overlayProgressLabel = this.dfc.querySelector('.jsOverlayProgressLabel');
			this.overlayProgressBar = this.dfc.querySelector('.jsOverlayProgressBar');
			this.overlayClose = this.dfc.querySelector('.jsOverlayClose');

			// Stripe needs access to some fields
			this.stripeRendered = false;
			this.cc_first_name = this.dfc.querySelector(`#${this.ns}cc_first_name`);
			this.cc_last_name = this.dfc.querySelector(`#${this.ns}cc_last_name`);
			this.address = this.dfc.querySelector(`#${this.ns}address`);
			this.city = this.dfc.querySelector(`#${this.ns}city`);
			this.zip = this.dfc.querySelector(`#${this.ns}zip`);
			this.country = this.dfc.querySelector(`#${this.ns}country`);
			this.state = this.dfc.querySelector(`#${this.ns}state`);
			this.province = this.dfc.querySelector(`#${this.ns}province`);

			// Plaid
			this.plaidBtn = this.dfc.querySelector(`#${this.ns}linkButton`);
			//this.linkHandler = null

			if ( this.form.dataset.inHonorOf )
			{
				this.showInHonorOfText();
			}

			// Show donation type selection
			this.renderHiddenFields();
			this.renderRecurrence();
			this.renderContents();
			this.renderSuggestedAmounts();
			this.toggleStateField();
			//this.renderStripe();
			this.updateDonationSummaryAmount();

			// Watch for various changes
			this.watchFields();
			this.watchNameFields();
			this.watchRecurrenceButtons();
			this.watchSuggestedAmounts();
			this.watchAmountField();
			this.watchTransactionFeesField();
			this.watchPaginationControls();
			this.watchMailcheckFields();
			this.watchSuggestedEmails();
			this.watchSuggestedEmailCloseButton();
			this.watchCountry();
			this.watchForDonorIdCheck();
			this.watchPlaidClick();
			this.watchFormSubmit();

		} // init()

		isNumber(n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		}

		renderHiddenFields()
		{
			this._settings.hiddenFields.forEach(fieldData => {
				let hiddenField = document.createElement('input');
				hiddenField.type = 'hidden';
				hiddenField.name = fieldData.name;
				hiddenField.value = fieldData.value;
				this.hiddenFields.appendChild(hiddenField);
			});
		}

		// Utility to create radio buttons
		createRadio(settings)
		{
			// Create the radio Field
			let field = document.createElement('input');
			field.type = 'radio';
			field.name = settings.name;
			field.value = settings.value;
			field.id = settings.id;
			field.checked = settings.checked;
			settings.class ? field.classList.add(settings.class) : null;
			settings.parent.appendChild(field);
			// Create the label
			let label = document.createElement('label');
			label.setAttribute('for', field.id);
			label.innerHTML = settings.labelText;
			settings.parent.appendChild(label);
		}

		// For handling errors
		handleError(err_msg)
		{
			this.handleAppDonateResponse(this, setError(err_msg));
		}

	/*
	########  ########  ######  ##     ## ########  ########  ######## ##    ##  ######  ########
	##     ## ##       ##    ## ##     ## ##     ## ##     ## ##       ###   ## ##    ## ##
	##     ## ##       ##       ##     ## ##     ## ##     ## ##       ####  ## ##       ##
	########  ######   ##       ##     ## ########  ########  ######   ## ## ## ##       ######
	##   ##   ##       ##       ##     ## ##   ##   ##   ##   ##       ##  #### ##       ##
	##    ##  ##       ##    ## ##     ## ##    ##  ##    ##  ##       ##   ### ##    ## ##
	##     ## ########  ######   #######  ##     ## ##     ## ######## ##    ##  ######  ########
		Recurring Donation Options
		-------------------------------------------------------------
	*/
		// Show recurrence buttons
		renderRecurrence()
		{
			if(showDebug) console.group('renderRecurrence()');

			// Common settings
			let recurrenceSettings = {
				parent: this.dfc.querySelector('.recurrence'),
				name: 'frequency',
				class: 'jsFrequencyTab'
			};

			// Single settings
			let singleSettings = Object.assign({}, recurrenceSettings);
			singleSettings.value = 'single';
			singleSettings.id = this.ns + 'tab--single';
			// singleSettings.class = 'jsTabSingle';
			singleSettings.labelText = `Single<span class="extraLabelText"> Gift</span>`;

			// Monthly settings
			let monthlySettings = Object.assign({}, recurrenceSettings);
			monthlySettings.value = 'monthly';
			monthlySettings.id = this.ns + 'tab--monthly';
			// monthlySettings.class = 'jsTabMonthly';
			monthlySettings.labelText = `Monthly<span class="extraLabelText"> Gift</span> <svg class="icon" id="icon-shield" viewBox="0 0 28 32">
				<path d="M28 4.506l-4.123-4.506c0 0-2.493 1.858-5.083 1.858s-4.794-1.858-4.794-1.858c0 0-2.205 1.858-4.794 1.858s-5.083-1.858-5.083-1.858l-4.123 4.506c0 0 2.127 1.115 2.127 3.714s-1.934 3.205-1.934 8.733c-0.002 10.31 13.807 15.047 13.807 15.047s13.809-4.737 13.809-15.047c0-5.526-1.934-6.134-1.934-8.733-0.002-2.6 2.125-3.714 2.125-3.714zM11.389 21.333l-0.002-0.002-0.002 0.002-4.385-4.118 1.782-1.674 2.605 2.447 8.609-8.084 1.782 1.673-10.389 9.755z"></path>
			</svg>`;

			// Annual settings
			let annualSettings = Object.assign({}, recurrenceSettings);
			annualSettings.value = 'annually';
			annualSettings.id = this.ns + 'tab--annual';
			// annualSettings.class = 'jsTabAnnual';
			annualSettings.labelText = `Annual<span class="extraLabelText"> Gift</span>`;

			if(showDebug) console.log('this.recurrenceChanged(this.defaultRecurrence)');

			this.recurrenceChanged(this.defaultRecurrence);

			if (this.recurrenceTypes.single)
			{
				// If this is the default recurrence, render it checked
				singleSettings.checked = this.defaultRecurrence == 'single';
				this.createRadio(singleSettings);
			}
			if (this.recurrenceTypes.monthly)
			{
				monthlySettings.checked = this.defaultRecurrence == 'monthly';
				this.createRadio(monthlySettings);
			}
			if (this.recurrenceTypes.annual)
			{
				annualSettings.checked = this.defaultRecurrence == 'annual';
				this.createRadio(annualSettings);
			}
			if(showDebug) console.groupEnd();
		}

		// Watch for clicks on the recurrence buttons
		watchRecurrenceButtons()
		{
			let recurrenceControls = this.dfc.querySelectorAll('.jsFrequencyTab');
			recurrenceControls.forEach(tab => {
				tab.addEventListener('click', () => {
					switch (tab.value) {
						case 'annually':
							this.recurrenceChanged('annual');
							break;

						default:
							this.recurrenceChanged(tab.value);
							break;
					}
				});
			});
		}

		// Handle changes to the recurrence buttons
		recurrenceChanged(currentRecurrence)
		{
			// If the user toggles the recurrence on a page other than the first one, jump them back to the first page.
			let activePage = this.dfc.querySelector('.jsFormPage.active');
			if (activePage.id != this.ns + 'form-page--1')
			{
				this.changeToPage(`#${this.ns}form-page--1`);
			}

			this.form.dataset.recurrence = currentRecurrence;

			// Set amount field minimum
			this.visibleAmountField.setAttribute('min', this.min[currentRecurrence]);

			// Show default amount if field hasn't been altered by the user
			if (!this.amountIsDirty)
			{
				if (this._settings.amounts)
				{
					switch (this._settings.amounts.defaultAmounts[currentRecurrence])
					{
						case 'none':
							this.visibleAmountField.value = '';
							this.totalAmountField.value = '';
							break;

						default:
							this.visibleAmountField.value = this._settings.amounts.defaultAmounts[currentRecurrence];
							this.totalAmountField.value = this._settings.amounts.defaultAmounts[currentRecurrence];
							break;
					}
				}
			}

			// Indicate if the amount matches a suggested amount button
			this.highlightMatchingButtons(this.visibleAmountField.value);

			switch (currentRecurrence) {
				case 'single':
					this.donationRecurrenceText.style.display = 'none';
					this.giveButtonText.innerText = 'Give Now';
					this.donationNoteRecurrenceText.textContent = 'a one-time';
					break;
				case 'monthly':
					this.donationRecurrenceText.innerText = 'Monthly';
					this.donationRecurrenceText.style.display = 'inline';
					this.giveButtonText.innerText = 'Give Monthly Gift';
					this.donationNoteRecurrenceText.textContent = 'a monthly';
					break;
				case 'annual':
					this.donationRecurrenceText.innerText = 'Annual';
					this.donationRecurrenceText.style.display = 'inline';
					this.giveButtonText.innerText = 'Give Annual Gift';
					this.donationNoteRecurrenceText.textContent = 'an annual';
					break;
				default:
					break;
			}
			this.updateSuggestedAmountText(currentRecurrence);

			this.updateTransactionFees();
			this.updateDonationSummaryRecurrence(currentRecurrence);

			activePage.querySelectorAll('input, select').forEach(field =>
			{
				this.removeFieldError(field);
				this.hideErrorMessage(field);
			});
		}
	/*
	|  ######   #######  ##    ## ######## ######## ##    ## ########  ######
	| ##    ## ##     ## ###   ##    ##    ##       ###   ##    ##    ##    ##
	| ##       ##     ## ####  ##    ##    ##       ####  ##    ##    ##
	| ##       ##     ## ## ## ##    ##    ######   ## ## ##    ##     ######
	| ##       ##     ## ##  ####    ##    ##       ##  ####    ##          ##
	| ##    ## ##     ## ##   ###    ##    ##       ##   ###    ##    ##    ##
	|  ######   #######  ##    ##    ##    ######## ##    ##    ##     ######
		Contents
		----------------------------------------------------------------------
	*/

		renderContents()
		{
			if (this._settings.formContents)
			{
				this._settings.formContents.forEach(copyBlock => {
					let contentHTML = document.createElement('div');
					contentHTML.classList.add('copyBlock', `-${copyBlock.recurrence}`);
					contentHTML.innerHTML = `<h2 class="formPage__heading">${copyBlock.heading}</h2>
					<div class="text">${copyBlock.text}</div>`;
					this.dfc.querySelector('.textualContents').appendChild(contentHTML)
				});
			}
		}

		// Show or hide the "Select or " text according to if there are suggested amount buttons for the current recurrence mode.
		updateSuggestedAmountText(currentRecurrence)
		{
			if (this.dfc.querySelector('form[data-recurrence="' + currentRecurrence + '"] .suggestedAmount.-' + currentRecurrence) !== null)
			{
				this.hasSuggestedAmountsText.style.display = 'inline';
			} else {
				this.hasSuggestedAmountsText.style.display = 'none';
			}
		}

		showInHonorOfText()
		{
			let wordHonor = document.documentElement.lang == 'en-CA' ? 'honour' : 'honor';
			let text = `<p><strong>Want to give in ${wordHonor} of someone you love?</strong> Once you make your donation, send them a personalized eCard!</p>`;
			this.inHonorOfWrapper.innerHTML = text;
		}

	/*
	|  ######  ##     ##  ######    ######   ########  ######  ######## ######## ########
	| ##    ## ##     ## ##    ##  ##    ##  ##       ##    ##    ##    ##       ##     ##
	| ##       ##     ## ##        ##        ##       ##          ##    ##       ##     ##
	|  ######  ##     ## ##   #### ##   #### ######    ######     ##    ######   ##     ##
	|       ## ##     ## ##    ##  ##    ##  ##             ##    ##    ##       ##     ##
	| ##    ## ##     ## ##    ##  ##    ##  ##       ##    ##    ##    ##       ##     ##
	|  ######   #######   ######    ######   ########  ######     ##    ######## ########
	|
	|    ###    ##     ##  #######  ##     ## ##    ## ########    ########  ######## ##    ##
	|   ## ##   ###   ### ##     ## ##     ## ###   ##    ##       ##     ##    ##    ###   ##
	|  ##   ##  #### #### ##     ## ##     ## ####  ##    ##       ##     ##    ##    ####  ##
	| ##     ## ## ### ## ##     ## ##     ## ## ## ##    ##       ########     ##    ## ## ##
	| ######### ##     ## ##     ## ##     ## ##  ####    ##       ##     ##    ##    ##  ####
	| ##     ## ##     ## ##     ## ##     ## ##   ###    ##       ##     ##    ##    ##   ###
	| ##     ## ##     ##  #######   #######  ##    ##    ##       ########     ##    ##    ##
		Suggested Amount buttons
		-------------------------------------------------------------
		Render the suggested amount buttons for each recurrence (if any were specified in the template). Each set of buttons for a recurrence is wrapped in its own wrapper, which is also generated on the fly.
	*/
		renderSuggestedAmounts()
		{
			if (this._settings.amounts)
			{
				let amounts = this._settings.amounts;

				if (amounts.suggestedSingleAmounts.length)
				{
					// Create the wrapper
					let suggestedSingleAmountsWrapper = document.createElement('div');
					suggestedSingleAmountsWrapper.classList.add('suggestedAmounts', '-single', '-numAmounts-'+amounts.suggestedSingleAmounts.length);
					// if (amounts.suggestedSingleAmounts.length > 3)
					// {
					// 	suggestedSingleAmountsWrapper.classList.add('-wrap');
					// }

					// Create the buttons
					amounts.suggestedSingleAmounts.forEach(amnt => {
						let btn = document.createElement('button');
						btn.value = amnt;
						btn.innerText = '$' + amnt.toLocaleString();
						btn.type = 'button';
						btn.classList.add('suggestedAmount', '-single', 'jsSuggestedAmount');
						suggestedSingleAmountsWrapper.appendChild(btn);
					});

					this.amountWrapper.before(suggestedSingleAmountsWrapper);
				}
				if (amounts.suggestedMonthlyAmounts.length)
				{
					let suggestedMonthlyAmountsWrapper = document.createElement('div');
					suggestedMonthlyAmountsWrapper.classList.add('suggestedAmounts', '-monthly', '-numAmounts-'+amounts.suggestedMonthlyAmounts.length);
					// if (amounts.suggestedMonthlyAmounts.length > 3)
					// {
					// 	suggestedMonthlyAmountsWrapper.classList.add('-wrap');
					// }

					amounts.suggestedMonthlyAmounts.forEach(amnt => {
						let btn = document.createElement('button');
						btn.value = amnt;
						btn.innerText = '$' + amnt.toLocaleString();
						btn.type = 'button';
						btn.classList.add('suggestedAmount', '-monthly', 'jsSuggestedAmount');
						suggestedMonthlyAmountsWrapper.appendChild(btn);
					});

					this.amountWrapper.before(suggestedMonthlyAmountsWrapper);
				}
				if (amounts.suggestedAnnualAmounts.length)
				{
					let suggestedAnnualAmountsWrapper = document.createElement('div');
					suggestedAnnualAmountsWrapper.classList.add('suggestedAmounts', '-annual', '-numAmounts-'+amounts.suggestedAnnualAmounts.length);
					// if (amounts.suggestedAnnualAmounts.length > 3)
					// {
					// 	suggestedMonthlyAmountsWrapper.classList.add('-wrap');
					// }

					amounts.suggestedAnnualAmounts.forEach(amnt => {
						let btn = document.createElement('button');
						btn.value = amnt;
						btn.innerText = '$' + amnt.toLocaleString();
						btn.type = 'button';
						btn.classList.add('suggestedAmount', '-annual', 'jsSuggestedAmount');
						suggestedAnnualAmountsWrapper.appendChild(btn);
					});

					this.amountWrapper.before(suggestedAnnualAmountsWrapper);
				}
				this.updateSuggestedAmountText(this.defaultRecurrence);
				// Indicate if the amount matches a suggested amount button
				this.highlightMatchingButtons(this.visibleAmountField.value);
			}
		}

		resetSelectedAmountButton()
		{
			let amountBtns = this.dfc.querySelectorAll('.jsSuggestedAmount');
			amountBtns.forEach(btn => {
				btn.classList.remove('-selected');
			});
		}

		watchSuggestedAmounts()
		{
			let amountBtns = this.dfc.querySelectorAll('.jsSuggestedAmount');
			amountBtns.forEach(btn => {
				btn.addEventListener('click', () => {
					this.resetSelectedAmountButton();
					btn.classList.add('-selected');
					this.visibleAmountField.value = btn.value;
					// Trigger a change event when the value is updated programmatically.
					this.visibleAmountField.dispatchEvent(new Event('change'));
					this.checkFieldValidity(this.visibleAmountField);
				});
			});
		}

	/*
	|    ###    ##     ##  #######  ##     ## ##    ## ########
	|   ## ##   ###   ### ##     ## ##     ## ###   ##    ##
	|  ##   ##  #### #### ##     ## ##     ## ####  ##    ##
	| ##     ## ## ### ## ##     ## ##     ## ## ## ##    ##
	| ######### ##     ## ##     ## ##     ## ##  ####    ##
	| ##     ## ##     ## ##     ## ##     ## ##   ###    ##
	| ##     ## ##     ##  #######   #######  ##    ##    ##
		Amount field
		----------------------------------------------------------------------

	*/
		watchAmountField()
		{
			// When input amount changes
			this.visibleAmountField.addEventListener('change', (e) =>
			{
				// Mark the amount field as having been changed by the user, so we don't reset it to any defaults from here on out.
				this.amountIsDirty = true;

				// Get provided amount
				this.targetAmount = parseFloat(e.target.value).toFixed(2);

				// Keep amount field that actually gets submitted in sync with visible amount
				this.totalAmountField.value = this.targetAmount;

				// If we're covering fees, apply fees to the total amount field
				this.updateTransactionFees();

				// Update the amount shown in the donation summary
				this.updateDonationSummaryAmount();

				// Mark any suggested amount buttons that match the value in the amount field.
				this.highlightMatchingButtons(this.targetAmount);

			});
		}

		// Check if any suggested amount buttons match and highlight them.
		highlightMatchingButtons(amount)
		{
			let matchingButtons = this.dfc.querySelectorAll('.jsSuggestedAmount[value="' + parseFloat(amount).toFixed(0) + '"]');
			if (matchingButtons) {
				this.resetSelectedAmountButton();
				matchingButtons.forEach(btn => {
					btn.classList.add('-selected');
				});
			}
		}
	/*
	| ######## ########     ###    ##    ##  ######     ###     ######  ######## ####  #######  ##    ##
	|    ##    ##     ##   ## ##   ###   ## ##    ##   ## ##   ##    ##    ##     ##  ##     ## ###   ##
	|    ##    ##     ##  ##   ##  ####  ## ##        ##   ##  ##          ##     ##  ##     ## ####  ##
	|    ##    ########  ##     ## ## ## ##  ######  ##     ## ##          ##     ##  ##     ## ## ## ##
	|    ##    ##   ##   ######### ##  ####       ## ######### ##          ##     ##  ##     ## ##  ####
	|    ##    ##    ##  ##     ## ##   ### ##    ## ##     ## ##    ##    ##     ##  ##     ## ##   ###
	|    ##    ##     ## ##     ## ##    ##  ######  ##     ##  ######     ##    ####  #######  ##    ##
	|
	| ######## ######## ########  ######
	| ##       ##       ##       ##    ##
	| ##       ##       ##       ##
	| ######   ######   ######    ######
	| ##       ##       ##             ##
	| ##       ##       ##       ##    ##
	| ##       ######## ########  ######
		Cover Transaction Fees
		--------------------------------------------------------------
	*/
		// When donor chooses to cover transaction fees
		watchTransactionFeesField()
		{
			this.transactionFeesCheckbox.addEventListener('change', () => {
				this.updateTransactionFees();

				// Update the amount shown in the donation summary
				this.updateDonationSummaryAmount();
			});
		}

		updateTransactionFees()
		{
			// Get provided amount
			this.targetAmount = parseFloat(this.visibleAmountField.value).toFixed(2);

			if ( this.isNumber( this.visibleAmountField.value ) )
			{
				if (this.transactionFeesCheckbox.checked) {
					this.applyFees(this.targetAmount);
				} else {
					this.removeFees(this.targetAmount);
				}
			}
			// If there's no number, don't try to calculate fees
			else
			{
				this.removeFees(this.visibleAmountField.value);
			}
		}

		/**
		 *
		 * @param {Number} targetAmount This is the original amount the
		 * donor intended to give, before covering transaction fees.
		 */
		applyFees(targetAmount)
		{
			// The fees calculation differs depending on which give mode is selected
			if (this.paymentMethod == 'bank')
			{
				// ACH/bank has a flat 40 cent fee
				var fees = parseFloat(0.4).toFixed(2);
			}
			else
			{
				// Credit Card has a variable fee, and should be shown as default
				var fees = ( ( ( parseFloat(targetAmount) + 0.3 ) * 0.019 ) + 0.3 ).toFixed(2);
			}

			// yes, 0.3 needs to be here twice since we're calculating the FEES, not the new TOTAL.
			let newAmount = (parseFloat(targetAmount) + parseFloat(fees)).toFixed(2);

			// Update elements that show user what the fees amount is
			this.feesAmounts.forEach(el =>
			{
				el.textContent = fees;
			});

			// Update field that actually gets submitted
			this.totalAmountField.value = newAmount;

			// Show fees in label
			this.feesCheckedText.style.display = 'inline';
			this.feesUncheckedText.style.display = 'none';

			// Show fees in Donation Summary
			this.summaryCoverFees.forEach(el =>
			{
				el.classList.add('-shown');
			});
		}

		/**
		 *
		 * @param {Number} targetAmount This is the original amount the donor
		 * intended to give, before covering transaction fees.
		 */
		removeFees(targetAmount)
		{
			// this.feesAmount.innerHTML = '';
			this.feesAmounts.forEach(el =>
			{
				el.textContent = '';
			});
			this.totalAmountField.value = targetAmount;

			// Hide fees in label
			this.feesCheckedText.style.display = 'none';
			this.feesUncheckedText.style.display = 'inline';

			// Hide fees in Donation Summary
			this.summaryCoverFees.forEach(el =>
			{
				el.classList.remove('-shown');
			});
		}
	/*
	| ########   #######  ##    ##    ###    ######## ####  #######  ##    ##
	| ##     ## ##     ## ###   ##   ## ##      ##     ##  ##     ## ###   ##
	| ##     ## ##     ## ####  ##  ##   ##     ##     ##  ##     ## ####  ##
	| ##     ## ##     ## ## ## ## ##     ##    ##     ##  ##     ## ## ## ##
	| ##     ## ##     ## ##  #### #########    ##     ##  ##     ## ##  ####
	| ##     ## ##     ## ##   ### ##     ##    ##     ##  ##     ## ##   ###
	| ########   #######  ##    ## ##     ##    ##    ####  #######  ##    ##
	|
	|  ######  ##     ## ##     ## ##     ##    ###    ########  ##    ##
	| ##    ## ##     ## ###   ### ###   ###   ## ##   ##     ##  ##  ##
	| ##       ##     ## #### #### #### ####  ##   ##  ##     ##   ####
	|  ######  ##     ## ## ### ## ## ### ## ##     ## ########     ##
	|       ## ##     ## ##     ## ##     ## ######### ##   ##      ##
	| ##    ## ##     ## ##     ## ##     ## ##     ## ##    ##     ##
	|  ######   #######  ##     ## ##     ## ##     ## ##     ##    ##
	*/
		updateDonationSummaryAmount()
		{
			this.summaryAmounts.forEach(el => {
				el.textContent = this.visibleAmountField.value;
			});
		}

		// Update the donation summary text with the recurrence (if not a one-time gift)
		updateDonationSummaryRecurrence(mode)
		{
			let text = '';
			switch (mode)
			{
				case 'monthly':
					text = ' monthly';
					break;

				case 'annual':
					text = ' annually';
					break;

				default:
					text = '';
					break;
			}
			this.summaryRecurrences.forEach(span =>
			{
				span.textContent = text;
			});
		}


	/*
	########     ###     ######   #### ##    ##    ###    ######## ####  #######  ##    ##
	##     ##   ## ##   ##    ##   ##  ###   ##   ## ##      ##     ##  ##     ## ###   ##
	##     ##  ##   ##  ##         ##  ####  ##  ##   ##     ##     ##  ##     ## ####  ##
	########  ##     ## ##   ####  ##  ## ## ## ##     ##    ##     ##  ##     ## ## ## ##
	##        ######### ##    ##   ##  ##  #### #########    ##     ##  ##     ## ##  ####
	##        ##     ## ##    ##   ##  ##   ### ##     ##    ##     ##  ##     ## ##   ###
	##        ##     ##  ######   #### ##    ## ##     ##    ##    ####  #######  ##    ##
	*/
		watchPaginationControls()
		{
			// this.paginationControls.forEach(paginationButton => {
			// 	paginationButton.addEventListener('click', (e) => {
			// 		e.preventDefault();
			// 		this.changeToPage(paginationButton.getAttribute('href'));
			// 	});
			// });
			this.navButtonPrev.forEach(btn =>
			{
				btn.addEventListener('click', () =>
				{
					this.changeToPage(btn.dataset.target);
				});
			});
			this.navButtonNext.forEach(btn =>
			{
				btn.addEventListener('click', () =>
				{
					// e.preventDefault();
					// Which payment method did they choose?
					if (btn.dataset.paymentMethod)
					{
						// Set the paymentMethod var
						this.paymentMethod = btn.dataset.paymentMethod;
						// Set the give-mode attribute on the <form>
						this.form.dataset.paymentMethod = this.paymentMethod;
						// If the user chose to give by bank, initialize Plaid.
						if ( this.paymentMethod == 'bank' && this.navButtonNext.type === 'submit')
						{
							// Do not want to initPlaid() until we have
							// the donors contact info on the next page
						}
						// Else initialize Stripe
						else
						{
							this.initStripe();
						}
						this.updateTransactionFees();
					}
					// Make sure the current page is valid before switching
					if ( this.checkPageValidity() )
					{
						this.changeToPage(btn.dataset.target);
					}
					else
					{
						if(showDebug) console.warn("Not changing to the next page since this page has form inputs that aren't valid.");
					}
				});
			});
		}

		changeToPage(pageId)
		{
			this.formPages.forEach(page =>
			{
				page.classList.remove('active')
			});
			this.dfc.querySelector(pageId).classList.add('active');
		}
	/*
	| ##     ##    ###    ##       #### ########     ###    ######## ####  #######  ##    ##
	| ##     ##   ## ##   ##        ##  ##     ##   ## ##      ##     ##  ##     ## ###   ##
	| ##     ##  ##   ##  ##        ##  ##     ##  ##   ##     ##     ##  ##     ## ####  ##
	| ##     ## ##     ## ##        ##  ##     ## ##     ##    ##     ##  ##     ## ## ## ##
	|  ##   ##  ######### ##        ##  ##     ## #########    ##     ##  ##     ## ##  ####
	|   ## ##   ##     ## ##        ##  ##     ## ##     ##    ##     ##  ##     ## ##   ###
	|    ###    ##     ## ######## #### ########  ##     ##    ##    ####  #######  ##    ##

		Validation
		----------------------------------------------------------------------
	*/
		watchFields()
		{
			let allFields = this.form.querySelectorAll('input, select');
			allFields.forEach(field =>
			{
				field.addEventListener('blur', () =>
				{
					this.checkFieldValidity(field);
				});
			});
		}

		checkFieldValidity(field)
		{
			let isValidField = field.checkValidity();
			if ( isValidField )
			{
				if (field.classList.contains('-error'))
				{
					this.removeFieldError(field);
				}
				return true;
			}
			else
			// Invalid field
			{
				// If there's no error shown yet
				if ( ! field.classList.contains('-error') )
				{
					this.addFieldError(field);
				}
				return false;
			}
		}

		addFieldError(field)
		{
			// if(showDebug) console.info('The "#' + field.id + '" field is invalid.');
			field.classList.add('-error');
			this.showErrorMessage(field);
			field.addEventListener('keyup', () => {
				this.checkFieldValidity(field);
			});
		}

		removeFieldError(field)
		{
			field.classList.remove('-error');
			this.hideErrorMessage(field);
			field.removeEventListener('keyup', () => {
				this.checkFieldValidity(field);
			});
		}

		showErrorMessage(field, message)
		{
			// figure out text
			let errorText = "This field has errors.";
			if (message)
			{
				errorText = message;
			}
			else if (this.errorMessages[field.id])
			{
				if (field.validity.rangeUnderflow == true)
				{
					let msg = this.errorMessages[field.id].rangeUnderflow;
					errorText = msg.pre + field.min + msg.post;
				}
				else if (this.errorMessages[field.id].generic)
				{
					errorText = this.errorMessages[field.id].generic;
				}
				else
				{
					errorText = this.errorMessages[field.id];
				}
				// errorText = this.errorMessages[field.id];
			}
			else if (field.required)
			{
				errorText = "This field is required.";
			}

			let error = document.createElement('label');
			error.setAttribute('for', field.id);
			error.classList.add('errorMessage');
			error.role = 'alert';
			error.innerText = errorText;

			field.parentNode.appendChild(error);


			// display message
		}

		hideErrorMessage(field)
		{
			if ( field.id )
			{
				let errorMessage = field.parentNode.querySelector('label[for=' + field.id + '].errorMessage');
				if (errorMessage)
				{
					errorMessage.remove();
				}
			}
		}

		checkPageValidity()
		{
			// Reset error var
			let pageHasErrors = false;

			// Store active page
			let activePage = this.dfc.querySelector('.jsFormPage.active');

			// Find all required fields on active page
			let requiredFields = activePage.querySelectorAll('[required]');

			// Check each field for validity
			requiredFields.forEach(requiredField =>
			{
				// this.checkFieldValidity(requiredField);
				if ( ! this.checkFieldValidity(requiredField))
				{
					pageHasErrors = true;
				}
			});

			if (pageHasErrors) {
				return false;
			} else {
				return true;
			}
		}

	/**
	##    ##    ###    ##     ## ########     ######  ##        #######  ##    ## ########
	###   ##   ## ##   ###   ### ##          ##    ## ##       ##     ## ###   ## ##
	####  ##  ##   ##  #### #### ##          ##       ##       ##     ## ####  ## ##
	## ## ## ##     ## ## ### ## ######      ##       ##       ##     ## ## ## ## ######
	##  #### ######### ##     ## ##          ##       ##       ##     ## ##  #### ##
	##   ### ##     ## ##     ## ##          ##    ## ##       ##     ## ##   ### ##
	##    ## ##     ## ##     ## ########     ######  ########  #######  ##    ## ########
	/**
	 * Name Clone
	 * ------------------------------------------------------------------------
	 * Copies First Name & Last Name from page 2 to Page 3
	 */
		watchNameFields()
		{
			//  Billing Name
			let bfname = this.dfc.querySelector('[name="billing_first_name"]');
			let blname = this.dfc.querySelector('[name="billing_last_name"]');

			//  Credit Card Name
			let cfname = this.dfc.querySelector('[name="cc_first_name"]');
			let clname = this.dfc.querySelector('[name="cc_last_name"]');

			bfname.addEventListener('change', () => {
				cfname.value = bfname.value;
			});

			blname.addEventListener('change', () => {
				clname.value = blname.value;
			});
		}

	/*
	##     ##    ###    #### ##        ######  ##     ## ########  ######  ##    ##
	###   ###   ## ##    ##  ##       ##    ## ##     ## ##       ##    ## ##   ##
	#### ####  ##   ##   ##  ##       ##       ##     ## ##       ##       ##  ##
	## ### ## ##     ##  ##  ##       ##       ######### ######   ##       #####
	##     ## #########  ##  ##       ##       ##     ## ##       ##       ##  ##
	##     ## ##     ##  ##  ##       ##    ## ##     ## ##       ##    ## ##   ##
	##     ## ##     ## #### ########  ######  ##     ## ########  ######  ##    ##
	*/
		watchMailcheckFields()
		{
			let mailcheckFields = this.dfc.querySelectorAll('.jsMailcheck');
			mailcheckFields.forEach(field => {
				let suggestionBox = field.parentNode.querySelector('.jsSuggestedEmailBox');
				let suggestedAddress = suggestionBox.querySelector('.jsSuggestedEmailAddress');
				field.addEventListener('blur', () => {
					this.mailcheck.run(
					{
						email: field.value,
						suggested: function(suggestion)
						{
							field.classList.add('has-possible-typo');
							suggestedAddress.value = suggestion.full;
							suggestedAddress.innerHTML = `${suggestion.address}@<strong>${suggestion.domain}</strong>`;
							suggestionBox.classList.add('is-visible');
						},
						empty: function()
						{
							field.classList.remove('has-possible-typo');
							suggestionBox.classList.remove('is-visible');
						}
					});
				});
			});
		}

		watchSuggestedEmails()
		{
			let emailSuggestions = this.dfc.querySelectorAll('.jsSuggestedEmailAddress');
			emailSuggestions.forEach(emailSuggestion => {
				let suggestionBox = emailSuggestion.closest('.jsSuggestedEmailBox');
				let emailField = suggestionBox.parentNode.querySelector('.jsMailcheck');
				emailSuggestion.addEventListener('click', () =>
				{
					suggestionBox.classList.remove('is-visible');
					emailField.value = emailSuggestion.value;
					emailField.classList.remove('has-possible-typo');
					emailSuggestion.closest('form').checkValidity; // ? Untested
				});
			});
		}

		watchSuggestedEmailCloseButton()
		{
			let suggestedEmailCloseBtns = this.dfc.querySelectorAll('.jsSuggestedEmailClose');
			suggestedEmailCloseBtns.forEach(btn => {
				let suggestionBox = btn.closest('.jsSuggestedEmailBox');
				btn.addEventListener('click', () => {
					suggestionBox.classList.remove('is-visible');
					suggestionBox.parentNode.querySelector('.jsMailcheck').classList.remove('has-possible-typo');
				});
			});
		}
	/**
	|  ######   #######  ##     ## ##    ## ######## ########  ##    ##          ##
	| ##    ## ##     ## ##     ## ###   ##    ##    ##     ##  ##  ##          ##
	| ##       ##     ## ##     ## ####  ##    ##    ##     ##   ####          ##
	| ##       ##     ## ##     ## ## ## ##    ##    ########     ##          ##
	| ##       ##     ## ##     ## ##  ####    ##    ##   ##      ##         ##
	| ##    ## ##     ## ##     ## ##   ###    ##    ##    ##     ##        ##
	|  ######   #######   #######  ##    ##    ##    ##     ##    ##       ##
	|
	|  ######  ########    ###    ######## ########
	| ##    ##    ##      ## ##      ##    ##
	| ##          ##     ##   ##     ##    ##
	|  ######     ##    ##     ##    ##    ######
	|       ##    ##    #########    ##    ##
	| ##    ##    ##    ##     ##    ##    ##
	|  ######     ##    ##     ##    ##    ########
	|
	| ######## #### ######## ##       ########   ######
	| ##        ##  ##       ##       ##     ## ##    ##
	| ##        ##  ##       ##       ##     ## ##
	| ######    ##  ######   ##       ##     ##  ######
	| ##        ##  ##       ##       ##     ##       ##
	| ##        ##  ##       ##       ##     ## ##    ##
	| ##       #### ######## ######## ########   ######

	* Country / State fields
	* ------------------------------------------------------------------------
	*/

		toggleStateField()
		{
			// let stateField = this.dfc.querySelector('#state');
			let stateRow = this.dfc.querySelector('.jsStateField');
			let provinceRow = this.dfc.querySelector('.jsProvinceField');
			let zipLabel = this.dfc.querySelector('.jsZipLabel');
			switch (this.country.value)
			{
				// USA
				case 'US':
					stateRow.style.display = 'flex';
					provinceRow.style.display = 'none';
					this.state.disabled = false;
					this.province.disabled = true;
					zipLabel.innerText = 'Zip';
					break;

				// Canada
				case 'CA':
					stateRow.style.display = 'none';
					provinceRow.style.display = 'flex';
					this.state.disabled = true;
					this.province.disabled = false;
					zipLabel.innerText = 'Postal Code';
					break;

				// Rest of world
				default:
					stateRow.style.display = 'none';
					provinceRow.style.display = 'none';
					this.state.disabled = true;
					this.province.disabled = true;
					zipLabel.innerText = 'Postal Code';
					break;
			}
		}

		watchCountry()
		{
			this.country.addEventListener('change', () =>
			{
				this.toggleStateField();
			});
		}


/*
|  #######  ##     ## ######## ########  ##          ###    ##    ##
| ##     ## ##     ## ##       ##     ## ##         ## ##    ##  ##
| ##     ## ##     ## ##       ##     ## ##        ##   ##    ####
| ##     ## ##     ## ######   ########  ##       ##     ##    ##
| ##     ##  ##   ##  ##       ##   ##   ##       #########    ##
| ##     ##   ## ##   ##       ##    ##  ##       ##     ##    ##
|  #######     ###    ######## ##     ## ######## ##     ##    ##
*/

		// Change the heading in the overlay
		setOverlayHeading(text = '')
		{
			if (text)
			{
				this.overlayHeading.textContent = text;
				this.overlayHeading.classList.add('-shown');
			}
			else
			{
				this.overlayHeading.textContent = '';
				this.overlayHeading.classList.remove('-shown');
			}
		}

		// Change the test in the overlay
		setOverlayText(text = '')
		{
			if (text)
			{
				this.overlayText.textContent = text;
				this.overlayText.classList.add('-shown');
			}
			else
			{
				this.overlayText.textContent = '';
				this.overlayText.classList.remove('-shown');
			}
		}

		// Set progress bar to a specific step
		setProgressBar(value)
		{
			this.overlayProgressBar.value = value;
		}

		// Advance progress bar by one step
		incrementProgressBar(step = 1)
		{
			let max = this.overlayProgressBar.max;
			// If there's room to progress
			if (this.overlayProgressBar.value < max)
			{
				if (this.overlayProgressBar.value + step > max)
				{
					this.overlayProgressBar.value = max;
					return true;
				}
				else
				{
					this.overlayProgressBar.value += step;
					return this.overlayProgressBar.value;
				}
			}
			else
			{
				return false;
			}
		}

		// Change text of progress bar's label
		setProgressLabel(text)
		{
			this.overlayProgressLabel.textContent = text;
		}

		// Show overlay's close button
		showOverlayClose()
		{
			this.overlayClose.classList.add('-shown');
			this.watchOverlayClose()
		}

		// Hide overlay's close button
		hideOverlayClose()
		{
			this.overlayClose.classList.remove('-shown');
		}

		// Show entire overlay
		showOverlay()
		{
			this.overlay.classList.add('-shown');
		}

		// Hide entire overlay
		hideOverlay()
		{
			this.overlay.classList.remove('-shown');
		}

		// Show/Hide "processing" spinner in overlay
		overlayProcessing(mode = true)
		{
			if (mode)
			{
				this.overlay.classList.add('-isProcessing');
			}
			else
			{
				this.overlay.classList.remove('-isProcessing');
			}
		}

		// Overlay close
		watchOverlayClose()
		{
			this.overlayClose.addEventListener('click', () =>
			{
				this.hideOverlay();
				this.hideOverlayClose();
				this.setOverlayHeading(); // blank
				this.setOverlayText(); // blank
			});
		}

	/*
	########  ##          ###    #### ########
	##     ## ##         ## ##    ##  ##     ##
	##     ## ##        ##   ##   ##  ##     ##
	########  ##       ##     ##  ##  ##     ##
	##        ##       #########  ##  ##     ##
	##        ##       ##     ##  ##  ##     ##
	##        ######## ##     ## #### ########
		Plaid
		----------------------------------------------------------------------
	*/

		loadPlaidLibrary(postData) {
		  	return new Promise(function(resolve, reject) {
		    	// Check if Plaid is already loaded
		    	if (typeof Plaid !== 'undefined') {
		      		resolve(postData);
		    	} else {
					// Load the Plaid library dynamically
					var script = document.createElement('script');
					script.src = 'https://cdn.plaid.com/link/v2/stable/link-initialize.js';
					script.async = true;
					script.onload = function() {
						// Call the resolve function with the postData
						resolve(postData);
					};
					script.onerror = reject;
					document.body.appendChild(script);
		    	}
		  	});
		}

		initPlaid() {

		  	// Plaid library is loaded and ready to use
		  	// Your code that depends on the Plaid library
			const postData = {
				"billing_first_name": 	!!this.dfc.querySelector('input[name="billing_first_name"]') ? this.dfc.querySelector('input[name="billing_first_name"]').value : "",
				"billing_last_name": 	!!this.dfc.querySelector('input[name="billing_last_name"]') ? this.dfc.querySelector('input[name="billing_last_name"]').value : "",
				"email": 				!!this.dfc.querySelector('input[name="email"]') ? this.dfc.querySelector('input[name="email"]').value : "",
				"phone": 				!!this.dfc.querySelector('input[name="phone"]') ? this.dfc.querySelector('input[name="phone"]').value : "",
				// "billing_country": 	!!this.dfc.querySelector('select[name="billing_country"]') ? this.dfc.querySelector('select[name="billing_country"]').value : "",
				// "billing_state": 	!!this.dfc.querySelector('select[name="billing_state"]:not([disabled])') ? this.dfc.querySelector('select[name="billing_state"]:not([disabled])').value : "",
				// "billing_zip": 		!!this.dfc.querySelector('input[name="billing_zip"]') ? this.dfc.querySelector('input[name="billing_zip"]').value : "",
				// "billing_city": 		!!this.dfc.querySelector('input[name="billing_city"]') ? this.dfc.querySelector('input[name="billing_city"]').value : "",
				// "billing_address": 	!!this.dfc.querySelector('input[name="billing_address"]') ? this.dfc.querySelector('input[name="billing_address"]').value : "",
				// "amount": 			!!this.dfc.querySelector('input[name="amount"]') ? this.dfc.querySelector('input[name="amount"]').value : "",
				// "gau":				!!this.dfc.querySelector('select[name="gau"]') ? this.dfc.querySelector('select[name="gau"]').value : "",
				// "frequency": 		!!this.dfc.querySelector('input[name="frequency"]') ? this.dfc.querySelector('input[name="frequency"]:checked').value : "",
				"customer_id": 			!!this.dfc.querySelector('input[name="customer_id"]') ? this.dfc.querySelector('input[name="customer_id"]').value : ""
			}

			this.loadPlaidLibrary(postData).then(async (postData) => {

	            // Fetch the Link Token from the server using POST method
	            const response = await fetch(linkTokenEndpoint, {
	                method: 'POST',
	                headers: {
	                    'Content-Type': 'application/json',
	                },
	                body: JSON.stringify(postData),
	            });
	            const data = await response.json();

	            if (data.link_token) {

					// Load Plaid
					const linkHandler = Plaid.create({
						token: data.link_token,
						onSuccess: (public_token, metadata) =>
						{

							// Send the public_token and account ID to your app server
							this.sendPlaidData({
								public_token: public_token,
								account_id: metadata.account_id,
								site_handle: allFormSettings.site_handle,
							});
						},
						onExit: (err, metadata) =>
						{
							// The user exited the Link flow.
							if (err != null)
							{
								// The user encountered a Plaid API error prior to exiting
								console.log('Error: ', err);
							}
							console.log('Metadata:', metadata);
						}
					});

					linkHandler.open();
				}
				else
				{
	        		if(showDebug) console.log('Error generating Link Token:', data.error);
	        		this.handleError('Error generating Link Token:' + data.error);
	    		}


			}).catch(function(error) {
				// Failed to load the Plaid library
				console.log('Error loading Plaid library:', error);
				this.handleError('Error loading Plaid library:' + error);
			});

		}

		sendPlaidData(data)
		{
			this.setOverlayHeading('Thank You!');
			this.setOverlayText('Please wait while we process your donation.');
			this.setProgressBar(1);
			this.setProgressLabel("Processing...");

			this.showOverlay();
			this.overlayProcessing(true);

			// New request
			const xhr1 = new XMLHttpRequest();

			// create a JSON object
			const json = {
				public_token: data.public_token,
				account_id: data.account_id,
				site_handle: data.site_handle,
			};

			// Open connection to the donation script
			xhr1.open('POST', '/make-gift/btok.php');

			// set `Content-Type` header
			xhr1.setRequestHeader('Content-Type', 'application/json');

			// send rquest with JSON payload
			xhr1.send(JSON.stringify(json));

			// listen for `load` event
			xhr1.onload = () =>
			{

				// print JSON response
				if (xhr1.status >= 200 && xhr1.status < 300)
				{

					if(showDebug) console.log('start attaching plaid token fields');

					// parse JSON
					const response1 = JSON.parse(xhr1.responseText);

					// Plaid Stripe (Bank Account) Token
					let hiddenInputPlaidStripeToken = document.createElement("input");
					hiddenInputPlaidStripeToken.setAttribute("type", "hidden");
					hiddenInputPlaidStripeToken.setAttribute("name", "stripe_token");
					hiddenInputPlaidStripeToken.setAttribute("value", response1.stripe_bank_account_token);
					this.form.append(hiddenInputPlaidStripeToken);
					if(showDebug) console.log('stripe bank account token: ' + response1.stripe_bank_account_token);

					// Plaid Access Token
					let hiddenInputPlaidAccessToken = document.createElement("input");
					hiddenInputPlaidAccessToken.setAttribute("type", "hidden");
					hiddenInputPlaidAccessToken.setAttribute("name", "plaid_access_token");
					hiddenInputPlaidAccessToken.setAttribute("value", response1.access_token);
					this.form.append(hiddenInputPlaidAccessToken);
					if(showDebug) console.log('plaid access token: ' + response1.access_token);

					if(showDebug) console.log('attached plaid token fields');

					// Trigger form submit
					this.form.dispatchEvent(new Event("submit"));

				}
				else
				{
					this.handleError('Error retrieving the token');
				}

			};

		}

		watchPlaidClick()
		{
			// AJAX close
			this.plaidBtn.addEventListener('click', (e) =>
			{
				e.preventDefault();

				// Check if the form validation
				if ( this.checkPageValidity() )
				{
					this.initPlaid();
				}
			});
		}

/*
|	 ######  ##     ## ########  ######  ##    ##
|	##    ## ##     ## ##       ##    ## ##   ##
|	##       ##     ## ##       ##       ##  ##
|	##       ######### ######   ##       #####
|	##       ##     ## ##       ##       ##  ##
|	##    ## ##     ## ##       ##    ## ##   ##
|	 ######  ##     ## ########  ######  ##    ##
|
|	########   #######  ##    ##  #######  ########
|	##     ## ##     ## ###   ## ##     ## ##     ##
|	##     ## ##     ## ####  ## ##     ## ##     ##
|	##     ## ##     ## ## ## ## ##     ## ########
|	##     ## ##     ## ##  #### ##     ## ##   ##
|	##     ## ##     ## ##   ### ##     ## ##    ##
|	########   #######  ##    ##  #######  ##     ##
		Check Donor
		----------------------------------------------------------------------
*/

		watchForDonorIdCheck()
		{
			if(showDebug) console.group('watchForDonorIdCheck()');
			let checkDonorTriggers = this.dfc.querySelectorAll('.jsCheckCustomer');
			checkDonorTriggers.forEach(btn => {
				btn.addEventListener('click', () =>
				{
					// if ( allFormSettings.site_handle == 'ijmCa' )
					// {
						console.log('handleStripeClientSecret()');
						this.handleStripeClientSecret();
					// }
					// else
					// {
					// 	console.log('checkDonorId()');
					// 	this.checkDonorId();
					// }
				});
			});
			if(showDebug) console.groupEnd();
		}

		// Send AJAX request to check if customer already exists / has a donation
		checkDonorId()
		{
			if(showDebug) console.group('checkDonorId()');
			try {
				if(showDebug) console.info('Checking customer data');

				const xhr = new XMLHttpRequest();
				const json = {
					"email": this.dfc.querySelector('input[name="email"]').value,
					"frequency": this.dfc.querySelector('input[name="frequency"]:checked').value,
					"site_handle": allFormSettings.site_handle
				};

				// xhr.open("POST", "/make-gift/customer.php", true);
				xhr.open("POST", allFormSettings.check_customer_url_env, true);

				xhr.setRequestHeader("Content-Type", "application/json");

				// Send the request
				xhr.send( JSON.stringify(json) );

				// Listen for `load` event
				xhr.onload = () =>
				{

					// Print JSON response
					if (xhr.status >= 200 && xhr.status < 300)
					{
						if(showDebug) console.info('Customer data acquired');
						let response = JSON.parse(xhr.responseText);
						if (typeof xhr.responseText !== "undefined" && response.result.hasOwnProperty('customer_id'))
						{
							let customerId = response.result.customer_id;
							this.dfc.querySelector('[name="customer_id"]').value = customerId;
						}
					}
					else
					{
						// Handle error
						if(showDebug) console.info('Error checking customer');
					}
				}

			}
			catch(e)
			{
				if(showDebug) console.error(e);
			}
			if(showDebug) console.groupEnd();
		} // checkDonorId()

		/**
	|  ######  ######## ########  #### ########  ########
	| ##    ##    ##    ##     ##  ##  ##     ## ##
	| ##          ##    ##     ##  ##  ##     ## ##
	|  ######     ##    ########   ##  ########  ######
	|       ##    ##    ##   ##    ##  ##        ##
	| ##    ##    ##    ##    ##   ##  ##        ##
	|  ######     ##    ##     ## #### ##        ########
		* HANDLE STRIPE
		*/

		initStripe()
		{
			// Check if the Stripe has been initialized
			if ( stripe === null )
			{
				// Load in the Stripe js lib
				include("https://js.stripe.com/v3/?.js", () => {
					stripe = Stripe(allFormSettings.stripe_key, { 
						//apiVersion: '2023-10-16'
						apiVersion: '2024-06-20'
					});
					if ( !this.stripeRendered )
						this.renderStripe();
				});
			}
			// If Stripe initialized check if it has been rendered
			else
			{
				if ( !this.stripeRendered )
					this.renderStripe();
			}

		}

		renderStripe()
		{

			// Create an instance of Elements.
			const elements = stripe.elements();

			// Custom styling can be passed to options when creating an Element.
			// (Note that this demo uses a wider set of styles than the guide below.)
			var style = {
				base: {
					color: "#32325d",
					lineHeight: "18px",
					fontFamily: "\"Helvetica Neue\", Helvetica, sans-serif",
					fontSmoothing: "antialiased",
					fontSize: "16px",
					"::placeholder": {
						color: "#aab7c4"
					}
				},
				invalid: {
					color: "#fa755a",
					iconColor: "#fa755a"
				}
			};

			// Create an instance of the card Element.
			this.card = elements.create("card", {style: style, hidePostalCode: true});

			// Add an instance of the card Element into the `card-element` <div>.
			this.card.mount(`#${this.ns}card-element`);

			// Handle real-time validation errors from the card Element.
			this.card.addEventListener("change", (event) =>
			{
				// var displayError = document.getElementById(`${this.ns}card-errors`);
				if (event.error)
				{
					this.showErrorMessage(this.cardElement, event.error.message)
				}
				else
				{
					this.hideErrorMessage(this.cardElement)
				}
			});

			String.prototype.replaceAll = function(search, replacement)
			{
				var target = this;
				return target.split(search).join(replacement);
			};

			// Stripe rendered
			this.stripeRendered = true;

		} // renderStripe()


		// Retrieve the Stripe Client Secret
		handleStripeClientSecret()
		{

			if(showDebug) console.group('ClientSecret()');

			try {

				if(showDebug) console.info('Start Client Secret');

				// // Retrieve the frequency
				// let frequency = this.dfc.querySelector('input[name="frequency"]:checked').value

				const xhr = new XMLHttpRequest();

				const json = {
					"billing_first_name": 			!!this.dfc.querySelector('input[name="billing_first_name"]') ? this.dfc.querySelector('input[name="billing_first_name"]').value : "",
					"billing_last_name": 			!!this.dfc.querySelector('input[name="billing_last_name"]') ? this.dfc.querySelector('input[name="billing_last_name"]').value : "",
					"email": 						!!this.dfc.querySelector('input[name="email"]') ? this.dfc.querySelector('input[name="email"]').value : "",
					"email_opt_in": 				!!this.dfc.querySelector('input[name="email_opt_in"]:checked') ? 1 : 0,
					"phone": 						!!this.dfc.querySelector('input[name="phone"]') ? this.dfc.querySelector('input[name="phone"]').value : "",
					"billing_country": 				!!this.dfc.querySelector('select[name="billing_country"]') ? this.dfc.querySelector('select[name="billing_country"]').value : "",
					"billing_state": 				!!this.dfc.querySelector('select[name="billing_state"]:not([disabled])') ? this.dfc.querySelector('select[name="billing_state"]:not([disabled])').value : "",
					"billing_zip": 					!!this.dfc.querySelector('input[name="billing_zip"]') ? this.dfc.querySelector('input[name="billing_zip"]').value : "",
					"billing_city": 				!!this.dfc.querySelector('input[name="billing_city"]') ? this.dfc.querySelector('input[name="billing_city"]').value : "",
					"billing_address": 				!!this.dfc.querySelector('input[name="billing_address"]') ? this.dfc.querySelector('input[name="billing_address"]').value : "",
					"amount": 						!!this.dfc.querySelector('input[name="amount"]') ? this.dfc.querySelector('input[name="amount"]').value : "",
					"gau":							!!this.dfc.querySelector('select[name="gau"]') ? this.dfc.querySelector('select[name="gau"]').value : "",
					"frequency": 					!!this.dfc.querySelector('input[name="frequency"]') ? this.dfc.querySelector('input[name="frequency"]:checked').value : "",
					"customer_id": 					!!this.dfc.querySelector('input[name="customer_id"]') ? this.dfc.querySelector('input[name="customer_id"]').value : "",
					"customer_email":				!!this.dfc.querySelector('input[name="customer_email"]') ? this.dfc.querySelector('input[name="customer_email"]').value : "",
					"site_handle": 					allFormSettings.site_handle,
					"campaign_id": 					!!this.dfc.querySelector('input[name="campaign_id"]') ? this.dfc.querySelector('input[name="campaign_id"]').value : "",
				    "fmv": 							!!this.dfc.querySelector('input[name="fmv"]') ? this.dfc.querySelector('input[name="fmv"]').value : "",
				    "source_channel": 				!!this.dfc.querySelector('input[name="source_channel"]') ? this.dfc.querySelector('input[name="source_channel"]').value : "",
				    "response_channel": 			!!this.dfc.querySelector('input[name="response_channel"]') ? this.dfc.querySelector('input[name="response_channel"]').value : "",
				    "version": 						!!this.dfc.querySelector('input[name="version"]') ? this.dfc.querySelector('input[name="version"]').value : "",
				    "donation_level": 				!!this.dfc.querySelector('input[name="donation_level"]') ? this.dfc.querySelector('input[name="donation_level"]').value : "",
				    "cover_transaction_fees": 		!!this.dfc.querySelector('input[name="cover_transaction_fees"]:checked') ? 1 : 0,
				    "gift_processor": 				!!this.dfc.querySelector('input[name="gift_processor"]') ? this.dfc.querySelector('input[name="gift_processor"]').value : "",
				    "redirect_to": 					!!this.dfc.querySelector('input[name="redirect_to"]') ? this.dfc.querySelector('input[name="redirect_to"]').value : "",
				    "payment_intent_id": 			!!this.dfc.querySelector('input[name="payment_intent_id"]') ? this.dfc.querySelector('input[name="payment_intent_id"]').value : "",
				    "client_secret": 				!!this.dfc.querySelector('input[name="client_secret"]') ? this.dfc.querySelector('input[name="client_secret"]').value : "",
				    "subscription_id": 				!!this.dfc.querySelector('input[name="subscription_id"]') ? this.dfc.querySelector('input[name="subscription_id"]').value : "",
				    "subscription_customer_id":		!!this.dfc.querySelector('input[name="subscription_customer_id"]') ? this.dfc.querySelector('input[name="subscription_customer_id"]').value : "",
				    "subscription_amount":			!!this.dfc.querySelector('input[name="subscription_amount"]') ? this.dfc.querySelector('input[name="subscription_amount"]').value : "",
				    "subscription_payment_intent_id": !!this.dfc.querySelector('input[name="subscription_payment_intent_id"]') ? this.dfc.querySelector('input[name="subscription_payment_intent_id"]').value : "",
				    "subscription_client_secret": 	!!this.dfc.querySelector('input[name="subscription_client_secret"]') ? this.dfc.querySelector('input[name="subscription_client_secret"]').value : ""
				};

				// console.log('start AJAX');
				xhr.open("POST", "/make-gift/client-secret.php", true);
				//xhr.open("POST", allFormSettings.check_customer_url_env, true);

				xhr.setRequestHeader("Content-Type", "application/json");

				// Send the request
				let postJSON = JSON.stringify(json);
				// console.log('json string');
				// console.log (JSON.stringify(json));
				xhr.send( postJSON );

				// Listen for `load` event
				xhr.onload = () =>
				{

					// Print JSON response
					// console.log('xhr status');
					// console.log(xhr.status);
					if (xhr.status >= 200 && xhr.status < 300)
					{
						if(showDebug) console.info('Client Secret Response');
						if(showDebug) console.log(xhr.responseText);
						let response = JSON.parse(xhr.responseText);
						if (typeof response !== "undefined"
							&& response.status !== "error" )
						{
							if (response.result.hasOwnProperty('customer_id'))
							{
								let customerId = response.result.customer_id;
								this.dfc.querySelector('[name="customer_id"]').value = customerId;
							}
							if (response.result.hasOwnProperty('new_customer'))
							{
								let newCustomer = response.result.new_customer;
								this.dfc.querySelector('[name="new_customer"]').value = newCustomer;
							}
							if (response.result.hasOwnProperty('payment_intent_id'))
							{
								let paymentIntentId = response.result.payment_intent_id;
								this.dfc.querySelector('[name="payment_intent_id"]').value = paymentIntentId;
							}
							if (response.result.hasOwnProperty('client_secret') )
							{
								let clientSecret = response.result.client_secret;
								this.dfc.querySelector('[name="client_secret"]').value = clientSecret;
							}
							if (response.result.hasOwnProperty('subscription_id'))
							{
								let subscriptionId = response.result.subscription_id;
								this.dfc.querySelector('[name="subscription_id"]').value = subscriptionId;
							}
							if (response.result.hasOwnProperty('subscription_client_secret') )
							{
								let subscriptionClientSecret = response.result.subscription_client_secret;
								this.dfc.querySelector('[name="subscription_client_secret"]').value = subscriptionClientSecret;
							}
						}
						else
						{
							if ( typeof response === "undefined" )
							{
								let errMsg = "Error-CSCS2: For some reason the donation failed to process. Please refresh your browser and try again.";
								if(showDebug) console.log(errMsg);
								this.handleError(errMsg);
							}
							else
							{
								let errMsg = "Error-CSCS3: " + response.message;
								if(showDebug) console.log(errMsg);
								this.handleError(errMsg);
							}

						}
					}
					else
					{
						// Handle error
						let errMsg = "Error-CSCS1: For some reason the donation failed to process. Please refresh your browser and try again.";
						if(showDebug) console.log(errMsg);
						this.handleError(errMsg);
					}
				}
			}
			catch(e)
			{
				if(showDebug) console.error(e);
				this.handleError("Error-CSCS4: " + e);
			}
			if(showDebug) console.groupEnd();
		}

	/*
	| ########  #######  ########  ##     ##
	| ##       ##     ## ##     ## ###   ###
	| ##       ##     ## ##     ## #### ####
	| ######   ##     ## ########  ## ### ##
	| ##       ##     ## ##   ##   ##     ##
	| ##       ##     ## ##    ##  ##     ##
	| ##        #######  ##     ## ##     ##
	|
	|  ######  ##     ## ########  ##     ## #### ########
	| ##    ## ##     ## ##     ## ###   ###  ##     ##
	| ##       ##     ## ##     ## #### ####  ##     ##
	|  ######  ##     ## ########  ## ### ##  ##     ##
	|       ## ##     ## ##     ## ##     ##  ##     ##
	| ##    ## ##     ## ##     ## ##     ##  ##     ##
	|  ######   #######  ########  ##     ## ####    ##
	FORM SUBMIT
	*/

		watchFormSubmit()
		{

			this.form.addEventListener('submit', (e) =>
			{
				e.preventDefault();

				// Check if the form validation
				if ( this.checkPageValidity() )
				{
					// Processing Step 1
					if(showDebug) console.info('Form submission initiated & page is valid, proceeding.');

					// progress
					this.overlayProcessing(true);
					this.setOverlayHeading('Thank You!');
					this.setOverlayText('Please wait while we process your donation.');
					this.setProgressBar(1);
					this.setProgressLabel("Processing...");
					this.showOverlay();

					// Get the Donation Captcha response
					if ( this.donationCaptchaResponse.value == "" )
					{

						if(showDebug) console.log('donationCaptchaResponse');
						// Trigger captcha if no captcha response found
						if ( this.form.dataset.formLocation == 'sidebar' )
						{
							if(showDebug) console.log('sidebar');
							grecaptcha.execute(window.sidebarDonationCaptcha);
						}
						else
						{
							if(showDebug) console.log('main');
							grecaptcha.execute(window.mainDonationCaptcha);
						}
					}
					else
					{
						if(showDebug) console.log('process donation');
						// Donation via Plaid
						if ( this.form.dataset.paymentMethod == "bank" )
						{

							// Submit the form
							const xhr = new XMLHttpRequest();
							const formData = new FormData(this.form);

							if(showDebug) console.log('form data');
							if(showDebug) {
								for (var pair of formData.entries()) {
								 	console.log(pair[0]+ ': ' + pair[1]);
								}
								console.log('submitted to: ' + allFormSettings.donate_url_env);
								// return false; // Short before submitting the donation
							}

							xhr.open("POST", allFormSettings.donate_url_env, true);

							// Send the request
							xhr.send(formData);

							// Listen for `load` event
							xhr.onload = () =>
							{

								// Print JSON response
								if (xhr.status >= 200 && xhr.status < 300)
								{

									// Reset the Stripe token and credit card
									if ( this.form.querySelector('[name="stripe_token"]') )
									{
										this.form.querySelector('[name="stripe_token"]').remove();
									}
									if ( this.card )
									{
										this.card.clear();
									}
									if ( this.form.querySelector('[name="plaid_access_token') )
									{
										this.form.querySelector('[name="plaid_access_token').remove();
									}

									// Parse JSON
									if(showDebug) console.log('AJAX Response...');
									if(showDebug) console.log(xhr.responseText);
									if ( isValidJSON(xhr.responseText) )
									{
										response = JSON.parse(xhr.responseText);
										// Handle the donation response
										this.handleAppDonateResponse(this, response);
									}
									else
									{
										this.handleError(xhr.responseText + " (Error-UPD1)");
									}

								}
								// HTTP Request Failed
								else
								{
									grecaptcha.reset();
									// grecaptcha.reset(window.mainDonationCaptcha);
									// grecaptcha.reset(window.sidebarDonationCaptcha);
									this.handleError(default_err_msg + ' (Error-UPD2)');
								}

							}
						}
						// Donation via Stripe
						else
						{

							// Prepare vars
							var cc_first_name = !!this.dfc.querySelector('input[name="billing_first_name"]') ? this.dfc.querySelector('input[name="billing_first_name"]').value : "";
							var cc_last_name = !!this.dfc.querySelector('input[name="billing_last_name"]') ? this.dfc.querySelector('input[name="billing_last_name"]').value : "";
							var cc_name = cc_first_name + " " + cc_last_name;
							var cc_address_country = !!this.dfc.querySelector('select[name="billing_country"]') ? this.dfc.querySelector('select[name="billing_country"]').value : "";
							var cc_address_state = !!this.dfc.querySelector('select[name="billing_state"]:not([disabled])') ? this.dfc.querySelector('select[name="billing_state"]:not([disabled])').value : "";
							var cc_address_zip = !!this.dfc.querySelector('input[name="billing_zip"]') ? this.dfc.querySelector('input[name="billing_zip"]').value : "";
							var cc_address_city = !!this.dfc.querySelector('input[name="billing_city"]') ? this.dfc.querySelector('input[name="billing_city"]').value : "";
							var cc_address_line1 = !!this.dfc.querySelector('input[name="billing_address"]') ? this.dfc.querySelector('input[name="billing_address"]').value : "";

							// var cc_first_name = !!this.form.billing_first_name ? this.form.billing_first_name.value.replaceAll('&', 'and').replaceAll('?', '') : "";
							// var cc_last_name = !!this.form.billing_last_name ? this.form.billing_last_name.value.replaceAll('&', 'and').replaceAll('?', '') : "";
							// var cc_name = cc_first_name + " " + cc_last_name;
							// var cc_address_line1 = !!this.form.billing_address ? this.form.billing_address.value.replaceAll('&', 'and').replaceAll('?', '') : "";
							// var cc_address_city = !!this.form.billing_city ? this.form.billing_city.value.replaceAll('&', 'and').replaceAll('?', '') : "";
							// var cc_address_zip = !!this.form.billing_zip ? this.form.billing_zip.value.replaceAll('&', 'and').replaceAll('?', '') : "";
							// var cc_address_country = !!this.form.billing_country ? this.form.billing_country.value.replaceAll('&', 'and').replaceAll('?', '') : "";

							// // Set the State value on if the country is CA
							// var cc_address_state = "";
							// if ( cc_address_country == 'CA' )
							// {
							//   cc_address_state = !!this.form.billing_state ? this.form.billing_state.value.replaceAll('&', 'and').replaceAll('?', '') : "";
							// }

							// Handle Donations
							try
							{

								// Retrieve the frequency
								let frequency = !!this.form.frequency ? this.form.frequency.value : "";
								var clientSecret = null;

								switch (frequency) {
									case 'monthly':
									case 'annually':
										clientSecret = !!this.form.querySelector('[name="subscription_client_secret"]') ? this.form.querySelector('[name="subscription_client_secret"]').value : null;
										break;

									default:
										clientSecret = !!this.form.querySelector('[name="client_secret"]') ? this.form.querySelector('[name="client_secret"]').value : null;
								}

								// Throw an error if the client secret is null
								if (clientSecret == null)
									throw default_err_msg + " (Error-CSC0)";

								// Start Stripe Confirm Card Payment
								stripe.confirmCardPayment(clientSecret, {
								    payment_method: {
								      card: this.card,
								      billing_details: {
								        name: cc_name.trim(),
								        address: {
								          city: cc_address_city,
								          country: cc_address_country,
								          line1: cc_address_line1,
								          postal_code: cc_address_zip,
								          state: cc_address_state
								        }
								      }
								    }
								}).then( (result) => {
								    if (result.error)
								    {
								      // Show error to your customer (for example, insufficient funds)
								      let errMsg = !!result.error.message ? result.error.message + ' (Error-CSC1A)' : default_err_msg;
								      if(showDebug) console.log(errMsg);
								      this.handleError(errMsg);
								    }
								    else
								    {
								      	// The payment has been processed!
								      	let paymentIntentStatus = !!result.paymentIntent.status ? result.paymentIntent.status : "failed";
								      	if (paymentIntentStatus === 'succeeded')
								      	{
								      		// Debug: Show the Payment Intent Object
								        	if(showDebug) console.log('Payment Intent Object:');
								        	if(showDebug) console.log(result.paymentIntent);

								        	if ( result.paymentIntent == null )
								        		throw default_err_msg + " (Error-CSC1B)";

								        	// Retrieve the Payment Intent Id
								        	let paymentIntent = result.paymentIntent;
								        	this.form.payment_intent_id.value = paymentIntent.id;

								        	// Debug: Show the Payment Intent Id
								        	if(showDebug) console.log("Payment Intent Id: " + paymentIntent.id);

								        	// Debug: Ensure the form has
								        	// the payment intent value
								        	if(showDebug) console.log("The Set Payment Intent Id");
								        	if(showDebug) console.log(this.form.payment_intent_id.value);

											// Submit the form
											const xhr = new XMLHttpRequest();
											const formData = new FormData(this.form);

											// Debug: The form object
											if(showDebug) console.log("Form Object:");
											if(showDebug) console.log(this.form);

											// Debug: The form values
											if(showDebug) console.log('Form Values:');
											if(showDebug) {
												for (const value of formData.values()) {
												 	console.log(value);
												}
											}

											xhr.open("POST", "/make-gift/donate.php", true);

											// Send the request
											xhr.send(formData);

											// Listen for `load` event
											xhr.onload = () =>
											{

												// Print JSON response
												if (xhr.status >= 200 && xhr.status < 300)
												{

													// Reset the Stripe token and credit card
													if ( this.dfc.querySelector('[name="client_secret"]') )
													{
														this.dfc.querySelector('[name="client_secret"]').value = "";
													}
													if ( this.dfc.querySelector('[name="subscription_client_secret"]') )
													{
														this.dfc.querySelector('[name="subscription_client_secret"]').value = "";
													}
													if ( this.card )
													{
														this.card.clear();
													}

													// Parse JSON
													if(showDebug) console.log('AJAX Response:');
													if(showDebug) console.log(xhr.responseText);
													if ( isValidJSON(xhr.responseText) )
													{
														response = JSON.parse(xhr.responseText);
														// Handle the donation response
														this.handleAppDonateResponse(this, response);
													}
													else
													{
														grecaptcha.reset();
														let errMsg = xhr.responseText + " (Error-CSC2)";
														if(showDebug) console.log(errMsg);
														this.handleError(errMsg);
													}

												}
												// HTTP Request Failed
												else
												{
													grecaptcha.reset();
													let errMsg
													this.handleError(default_err_msg + " (Error-CSC3)");
												}

											}
								      	}
								      	else
								      	{
								      		throw default_err_msg + " (Error-CSC4)";
								      	}
								    }
								});

							}
							catch(e)
							{
								grecaptcha.reset();
								if(showDebug) console.log(e);
								this.handleError(e);
							}

						}
					}
				}
				else
				{
					if(showDebug) console.warn("Not proceeding since this page has form inputs that aren't valid.");
				}
			}); // this.form.addEventListener
		} // watchFormSubmit()

	/*
	##     ##    ###    ##    ## ########  ##       ########
	##     ##   ## ##   ###   ## ##     ## ##       ##
	##     ##  ##   ##  ####  ## ##     ## ##       ##
	######### ##     ## ## ## ## ##     ## ##       ######
	##     ## ######### ##  #### ##     ## ##       ##
	##     ## ##     ## ##   ### ##     ## ##       ##
	##     ## ##     ## ##    ## ########  ######## ########

	########  ########  ######  ########   #######  ##    ##  ######  ########
	##     ## ##       ##    ## ##     ## ##     ## ###   ## ##    ## ##
	##     ## ##       ##       ##     ## ##     ## ####  ## ##       ##
	########  ######    ######  ########  ##     ## ## ## ##  ######  ######
	##   ##   ##             ## ##        ##     ## ##  ####       ## ##
	##    ##  ##       ##    ## ##        ##     ## ##   ### ##    ## ##
	##     ## ########  ######  ##         #######  ##    ##  ######  ########
	*/

		handleAppDonateResponse(self, response)
		{
			// Initialize output
			var output = "";
			var form = self.form;

			// If redirect do so now
			if ( response.status == "ok" )
			{
				// Reset the form for another donation
				form.reset();

				// Build URL
				var strURLParams = "";

				// Transaction Id
				if ( typeof response.result.id !== "undefined" )
				{
					strURLParams += strURLParams === "" ? "?" : "&";
					strURLParams += "id=" + encodeURIComponent(response.result.id);
				}
				// Amount
				if ( typeof response.result.amount !== "undefined" )
				{
					strURLParams += strURLParams === "" ? "?" : "&";
					strURLParams += "amount=" + encodeURIComponent(response.result.amount);
				}
				// Frequency
				if ( typeof response.result.frequency !== "undefined" )
				{
					strURLParams += strURLParams === "" ? "?" : "&";
					strURLParams += "frequency=" + encodeURIComponent(response.result.frequency);
				}

				// Processing Step 4
				this.setProgressBar(4);
				this.setProgressLabel('Redirecting...');

				if (allFormSettings.do_redirect_env)
				{
					// Handle success
					if ( typeof response.result.redirect_to !== "undefined" )
					{

						window.location.href = response.result.redirect_to + strURLParams;
						//if(showDebug) console.log('window.location.href = ' + response.result.redirect_to + strURLParams);
					}
					else
					{
						window.location.href = '/give/thank-you' + strURLParams;
					}
				}
				else
				{

					// Handle success
					if ( typeof response.result.redirect_to !== "undefined" )
					{

						// window.location.href = response.result.redirect_to + strURLParams;
						if(showDebug) console.log('window.location.href = ' + response.result.redirect_to + strURLParams);
					}
					else
					{
						// window.location.href = '/give/thank-you' + strURLParams;
						if(showDebug) console.log('window.location.href = "/give/thank-you"' + strURLParams);
					}
				}

			}
			else // response.status is NOT "ok"
			{

				// Reset the donation form captcha
				grecaptcha.reset();
				// grecaptcha.reset(1);
				self.donationCaptchaResponse.value = '';

				// If error response, output response
				// otherwise redirect
				if ( response.message != "" )
				{
					output += response.message;
				}
				// General error
				else
				{
					output = 'Failed to process payment.';
				}
			}

			// Output response
			if ( output != "" )
			{
				this.overlayProcessing(false);
				this.setOverlayHeading('Oops');
				this.setOverlayText(output);
				this.showOverlayClose();
			}
		}

	}

	// Retrieve all donation form containers
	let donationFormContainers = document.querySelectorAll('.jsDonationFormContainer');

	// Loop through and init all of the donation forms on a page
	donationFormContainers.forEach(donationFormContainer => {
		new DonationForm(donationFormContainer, allFormSettings);
	});

} // if (typeof allFormSettings !== 'undefined')